import Privacy from "views/PrivacyPolicyView";

export default function Page() {
  return (
    <>
      <Privacy />
    </>
  );
}
